import { API_BUNDLE_PRODUCT } from 'utils/constants'
import Api from './axiosInstance'
import { CreateProductPayload } from 'types/bundleProduct'

type FetchBundleProductsParams = {
  limit: number
  page: number
  search?: string
  filters?: any
}

const fetchBundleProducts = ({
  limit,
  page,
  search,
  filters,
}: FetchBundleProductsParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_BUNDLE_PRODUCT.BUNDLE_PRODUCT}?${params}`,
  })
}

const createProduct = (data: CreateProductPayload) =>
  Api.post({ url: API_BUNDLE_PRODUCT.BUNDLE_PRODUCT, data })

const importBundleProducts = (key: string) =>
  Api.post({ url: API_BUNDLE_PRODUCT.IMPORT, data: { key } })

const downloadBundleProducts = (filters: Record<string, any>) => {
  const params = new URLSearchParams(filters)

  return Api.get({
    url: `${API_BUNDLE_PRODUCT.EXPORT}?${params}`,
  })
}

export {
  fetchBundleProducts,
  createProduct,
  importBundleProducts,
  downloadBundleProducts,
}
